import { JsonObject } from '../../../Assembler/dist/app/json/jsonObject.js';

/**
 * Represents a source file with its relative path and raw content
 * Key is stored in the dictionary for fast lookup
 */
export class SourceFile {
    /** Relative path from AppSite folder (e.g., "Common/center") */
    relativePath: string = '';

    /** Raw file content */
    content: string = '';

    /** Parsed JSON structure for JSON-backed source files when available */
    jsonStructure: JsonObject | null = null;
}
